import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ManageBoxesIcon from '@mui/icons-material/Dns';
import ManagePatientsIcon from '@mui/icons-material/SupervisorAccount';
import ManageUsersIcon from '@mui/icons-material/AccountBox';
import ManageAccountsIcon from '@mui/icons-material/AccountBalance';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link, Location } from "@reach/router";
import USER_ROLES from '../common/userroles';
import ConsoleIcon from '@mui/icons-material/IndeterminateCheckBox';
import Report from './Report';
import { Divider } from '@mui/material';
// import EventIcon from '@mui/icons-material/Event';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { withTranslation } from 'react-i18next';
import GroupsIcon from '@mui/icons-material/Groups';
import AttributionIcon from '@mui/icons-material/Attribution';
import MapIcon from '@mui/icons-material/Map';
import PaymentIcon from '@mui/icons-material/Payment';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ViewListIcon from '@mui/icons-material/ViewList';
import ExtensionIcon from '@mui/icons-material/Extension';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import StoreIcon from '@mui/icons-material/Store';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HotelIcon from '@mui/icons-material/Hotel';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CampaignIcon from '@mui/icons-material/Campaign';
import BadgeOutlined from '@mui/icons-material/BadgeOutlined';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import SmsOutlined from '@mui/icons-material/SmsOutlined';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import BusinessIcon from '@mui/icons-material/Business';
import { navActiveStyles, isNavPathActive } from './navActiveStyles';
import NavLockedBubble, { ActivateMark } from './NavLockedBubble';
import ReportLink, {
  isMarketplaceReportPath,
  MARKETPLACE_REPORT_PATHS,
} from './reportlink';
import NavMiniFlyout from './NavMiniFlyout';
import NavCollapsedTitle from './NavCollapsedTitle';
import CustomizeNavDialog from './CustomizeNavDialog';
import NavWalkthrough from './NavWalkthrough';
import {
  TOP_LEVEL_NAV,
  isTopLevelNavSectionOpen,
  toggleTopLevelNavSection,
  subscribeTopLevelNavAccordion,
  openTopLevelNavSection,
} from './navAccordion';
import {
  CUSTOM_BRAND_MESSAGING_KEY,
  CAMPAIGNS_KEY,
  EMAIL_TEMPLATES_PATH,
  SMS_TEMPLATES_PATH,
  LINK_MESSAGES_PATH,
  STAFF_TEMPLATES_PATH,
  CAMPAIGNS_PATH,
  CAMPAIGNS_LIST_PATH,
  CAMPAIGNS_ANALYTICS_PATH,
  TEMPLATES_PATH_PREFIX,
  displaySolutionTitle,
  fetchEntitlements,
  getConsoleTypeFromSearch,
  getFeatureLockedRedirectPath,
  getPromotedProductNavPath,
  getSelectedBoxId,
  isComingSoonFeature,
  isDeliverPrescriptionPath,
  isFeatureGeoBlocked,
  isFeatureUsable,
  isPromotedEntitlementPending,
  isPromotedFeaturePath,
} from '../../utils/productLicensing';
import { startDeliverTabLoading } from '../../utils/deliverTabLoading';
import {
  fetchNavPreferencesFromApi,
  getVisiblePromotedProducts,
  loadNavPreferences,
  persistNavPreferencesToApi,
  rankPromotedProducts,
  saveNavPreferences,
  splitPromotedNavItems,
} from '../../utils/productNav';
import { canShowNavItem, hasAllowedPermission, isStockerNavGated, syncStockerUserFlag } from '../../utils/stockerNavPermissions';

const NAV_MENU_MAX_WIDTH = Math.round(360 * 1.15);

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: NAV_MENU_MAX_WIDTH,
    backgroundColor: theme.palette.background.paper,
    ...navActiveStyles,
  },
  nested: {
    '&.MuiButtonBase-root': {
      paddingLeft: '48px !important',
    },
    paddingRight: theme.spacing.unit * 2,
    '& .MuiListItemText-root': {
      overflow: 'visible',
      wordWrap: 'break-word',
    },
    '& .MuiListItemText-primary': {
      overflow: 'visible',
      wordWrap: 'break-word',
    },
    '& .MuiListItemText-secondary': {
      overflow: 'visible',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
    },
  },
  submenuItem: {
    '&.MuiButtonBase-root': {
      display: 'flex',
      minHeight: 32,
      padding: '4px 16px 4px 48px !important',
      marginBottom: 2,
    },
  },
  submenuItemNested: {
    '&.MuiButtonBase-root': {
      display: 'flex',
      minHeight: 32,
      padding: '4px 16px 4px 80px !important',
      marginBottom: 2,
    },
  },
  submenuIndent: {
    paddingLeft: 24,
  },
  nestedTwice: {
    '&.MuiButtonBase-root': {
      paddingLeft: '64px !important',
    },
    paddingRight: theme.spacing.unit * 2,
    '& .MuiListItemText-root': {
      overflow: 'visible',
      wordWrap: 'break-word',
    },
    '& .MuiListItemText-primary': {
      overflow: 'visible',
      wordWrap: 'break-word',
    },
    '& .MuiListItemText-secondary': {
      overflow: 'visible',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
    },
  },
  textColor:{
    color: '#334155',
  },
  listItem:{
    '&.MuiButtonBase-root': {
      display: 'flex',
      minHeight: 32,
      padding: '4px 24px',
      marginBottom: 2,
    },
    '& .MuiListItemText-root': {
      overflow: 'visible',
      flex: '1 1 auto',
      minWidth: 0,
    },
    '& .MuiListItemText-primary': {
      overflow: 'visible',
      width: '100%',
    },
  },
  navLink: {
    textDecoration: 'none',
    display: 'block',
    color: 'inherit',
  },
  navItemLabel: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 8,
  },
  navItemName: {
    minWidth: 0,
  },
  navItemTrailing: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    marginLeft: 'auto',
    flexShrink: 0,
  },
  navItemMark: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 14,
    height: 14,
    flexShrink: 0,
    marginRight: -3,
  },
  manageAccountsNested: {
    '&.MuiButtonBase-root': {
      paddingLeft: '64px !important',
    },
  },
  manageSectionMenu: {
    paddingLeft: 0,
  },
  manageSectionToggle: {
    '&.MuiButtonBase-root': {
      paddingLeft: '48px !important',
    },
  },
  manageSectionLabel: {
    fontSize: '0.8rem !important',
    fontWeight: 500,
    color: '#334155',
  },
  nestedNavIcon: {
    minWidth: 28,
    color: 'inherit',
  },
  productsSectionLabel: {
    margin: '2px 8px',
    padding: '4px 12px',
    borderRadius: 6,
    fontSize: '0.8rem',
    fontWeight: 500,
    letterSpacing: 0,
    textTransform: 'none',
    backgroundColor: '#f1f5f9',
    color: '#334155',
    border: 0,
    borderLeft: '3px solid #94a3b8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: 'calc(100% - 16px)',
    fontFamily: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
  },
  customizeNavButton: {
    border: 0,
    background: 'transparent',
    color: '#0284c7',
    fontSize: '0.8rem',
    fontWeight: 700,
    letterSpacing: 0,
    textTransform: 'none',
    cursor: 'pointer',
    padding: 0,
  },
  helpTourList: {
    paddingBottom: 2,
  },
  helpTourItem: {
    alignItems: 'flex-start',
    paddingTop: 4,
    paddingBottom: 4,
    marginBottom: 2,
  },
});

class MenuList extends React.Component {
  state = {
    rolepermissionmenu: false,
    DeliveryTech: false,
    DeliveryTechReports: true,
    notification: false,
    manageAccountsSectionsOpen: {},
    promotedEntitlements: null,
    pinnedKeys: null,
    tourSeen: false,
    customizeOpen: false,
    productsExpanded: true,
    solutionsOpen: false,
    solutionsStudioOpen: false,
    solutionsCampaignsOpen: false,
  };
  handleManageUsersClick = () => {
    toggleTopLevelNavSection(TOP_LEVEL_NAV.MANAGE_USERS);
  };
  handleHelpToursClick = () => {
    toggleTopLevelNavSection(TOP_LEVEL_NAV.HELP_TOURS);
  };
  handleTemplatesClick = () => {
    toggleTopLevelNavSection(TOP_LEVEL_NAV.TEMPLATES);
  };
  handleCampaignsClick = () => {
    toggleTopLevelNavSection(TOP_LEVEL_NAV.CAMPAIGNS);
  };
  handleSolutionsStudioToggle = () => {
    this.setState((state) => ({
      solutionsStudioOpen: !state.solutionsStudioOpen,
    }));
  };
  handleSolutionsCampaignsToggle = () => {
    this.setState((state) => ({
      solutionsCampaignsOpen: !state.solutionsCampaignsOpen,
    }));
  };

  isStudioPath = (pathname) =>
    isNavPathActive(pathname, TEMPLATES_PATH_PREFIX, { prefix: true }) ||
    isNavPathActive(pathname, TEMPLATES_PATH_PREFIX) ||
    isNavPathActive(pathname, '/home/manage/message-control-center');

  isCampaignsPath = (pathname) =>
    isNavPathActive(pathname, CAMPAIGNS_PATH) ||
    isNavPathActive(pathname, CAMPAIGNS_PATH, { prefix: true });

  // Open only the Studio menu that is actually on screen. A pinned Studio
  // lives under Products; otherwise it lives under Solutions.
  _wasOnTemplates = false;
  _wasOnCampaigns = false;
  _navShowConsole = false;

  isStudioInProducts = () => {
    const split = this.getPromotedNavSplit(!!this._navShowConsole);
    return (split.top || []).some(
      (entry) =>
        entry &&
        entry.product &&
        entry.product.feature_key === CUSTOM_BRAND_MESSAGING_KEY
    );
  };

  syncAccordionFromRoute = () => {
    const onTemplates = !!this._currentOnTemplates;
    if (onTemplates && !this._wasOnTemplates) {
      if (this.isStudioInProducts()) {
        openTopLevelNavSection(TOP_LEVEL_NAV.TEMPLATES);
        if (!this.state.productsExpanded) {
          this.setState({ productsExpanded: true });
        }
      } else if (!this.state.solutionsOpen || !this.state.solutionsStudioOpen) {
        this.setState({ solutionsOpen: true, solutionsStudioOpen: true });
      }
    }
    this._wasOnTemplates = onTemplates;
    const onCampaigns = !!this._currentOnCampaigns;
    if (onCampaigns && !this._wasOnCampaigns) {
      openTopLevelNavSection(TOP_LEVEL_NAV.CAMPAIGNS);
    }
    this._wasOnCampaigns = onCampaigns;
  };

  componentDidUpdate() {
    this.syncAccordionFromRoute();
  }
  handleCompleteTour = () => {
    console.log('[Managemenulink] Complete Tour clicked from collapsible menu');
    if (this.props.onStartTour) {
      this.props.onStartTour();
    }
  };
  handleFeaturesTour = () => {
    if (this.props.onStartFeaturesTour) {
      this.props.onStartFeaturesTour();
    }
  };
  handleFeaturesHelp = () => {
    if (this.props.onOpenFeaturesHelp) {
      this.props.onOpenFeaturesHelp();
    }
  };

  renderHelpTourItems = () => {
    const { classes, t } = this.props;
    const showFeaturesHelp = true;
    const secondaryStyle = {
      fontSize: '0.7rem',
      lineHeight: 1.4,
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    };
    const primaryStyle = { fontSize: '0.8rem', fontWeight: 500, lineHeight: 1.4 };
    return (
      <List component="div" disablePadding className={classes.helpTourList}>
        <ListItemButton
          className={`${classes.nested} ${classes.helpTourItem}`}
          onClick={this.handleCompleteTour}
        >
          <ListItemIcon style={{ minWidth: 28 }}>
            <PlayArrowIcon style={{ color: '#475569', fontSize: 16 }} />
          </ListItemIcon>
          <ListItemText
            primary={t("Tour.CompleteTour") || "Complete Tour"}
            secondary={t("Tour.CompleteTourDescription") || "All new features in 2 minutes"}
            primaryTypographyProps={{ style: primaryStyle }}
            secondaryTypographyProps={{ style: secondaryStyle }}
            className={classes.textColor}
            style={{ margin: 0, paddingRight: 8 }}
          />
        </ListItemButton>
        <ListItemButton
          className={`${classes.nested} ${classes.helpTourItem}`}
          onClick={this.handleCompleteTour}
        >
          <ListItemIcon style={{ minWidth: 28 }}>
            <ViewListIcon style={{ color: '#475569', fontSize: 16 }} />
          </ListItemIcon>
          <ListItemText
            primary={t("Tour.PaginationTitle") || "Enhanced Kiosk Pagination"}
            secondary={t("Tour.PaginationContent") || "Navigate easily through the kiosk extensions"}
            primaryTypographyProps={{ style: primaryStyle }}
            secondaryTypographyProps={{ style: secondaryStyle }}
            className={classes.textColor}
            style={{ margin: 0, paddingRight: 8 }}
          />
        </ListItemButton>
        {showFeaturesHelp ? (
          <ListItemButton
            className={`${classes.nested} ${classes.helpTourItem}`}
            onClick={this.handleFeaturesTour}
          >
            <ListItemIcon style={{ minWidth: 28 }}>
              <ExtensionIcon style={{ color: '#475569', fontSize: 16 }} />
            </ListItemIcon>
            <ListItemText
              primary={t("Tour.FeaturesTour") || "Solutions & Licensing"}
              secondary={t("Tour.FeaturesTourDescription") || "Request and enable licensed add-ons"}
              primaryTypographyProps={{ style: primaryStyle }}
              secondaryTypographyProps={{ style: secondaryStyle }}
              className={classes.textColor}
              style={{ margin: 0, paddingRight: 8 }}
            />
          </ListItemButton>
        ) : null}
        {showFeaturesHelp ? (
          <ListItemButton
            className={`${classes.nested} ${classes.helpTourItem}`}
            onClick={this.handleFeaturesHelp}
          >
            <ListItemIcon style={{ minWidth: 28 }}>
              <MenuBookIcon style={{ color: '#475569', fontSize: 16 }} />
            </ListItemIcon>
            <ListItemText
              primary={t("FeaturesHelp.OpenGuide") || "Help guide"}
              secondary={t("FeaturesHelp.MenuDescription") || "Illustrated Solutions walkthrough"}
              primaryTypographyProps={{ style: primaryStyle }}
              secondaryTypographyProps={{ style: secondaryStyle }}
              className={classes.textColor}
              style={{ margin: 0, paddingRight: 8 }}
            />
          </ListItemButton>
        ) : null}
      </List>
    );
  };
  componentDidMount() {
    this._navAccordionUnsub = subscribeTopLevelNavAccordion(() => {
      this.forceUpdate();
    });
    syncStockerUserFlag();
    const stockerGated = isStockerNavGated();
    let role = JSON.parse(sessionStorage.getItem('superadmin'));
    if (role === USER_ROLES.SUPERADMIN && !stockerGated) {
      this.setState({ rolepermissionmenu: true, notification: true });
    }
    let permissionUser = JSON.parse(sessionStorage.getItem('permissionUser'));
    if (permissionUser === USER_ROLES.DELIVERYTECH) {
      this.setState({ DeliveryTech: true })
    }
    this.loadPromotedEntitlements();
    this._onPromotedEntitlementFocus = () => {
      this.loadPromotedEntitlements();
    };
    window.addEventListener('focus', this._onPromotedEntitlementFocus);
    this._onOpenSolutionsNav = () => {
      this.setState({ solutionsOpen: true });
    };
    window.addEventListener('ilocalbox:open-solutions-nav', this._onOpenSolutionsNav);
    const prefs = loadNavPreferences();
    this.setState({
      pinnedKeys: prefs.pinnedKeys,
      tourSeen: prefs.tourSeen === true,
    });
    this.hydrateNavPreferences(prefs);
    this.syncAccordionFromRoute();
  }

  hydrateNavPreferences = (localPrefs) => {
    fetchNavPreferencesFromApi().then((remote) => {
      if (this._navPrefsDirty) {
        return;
      }
      if (remote && remote.hasPrefs) {
        this.applyRemoteNavPreferences(remote);
        return;
      }
      if (
        remote &&
        remote.hasPrefs === false &&
        localPrefs &&
        (Array.isArray(localPrefs.pinnedKeys) || localPrefs.tourSeen === true)
      ) {
        persistNavPreferencesToApi(localPrefs);
      }
    });
  };

  applyRemoteNavPreferences = (remote) => {
    if (!remote || remote.hasPrefs === false) {
      return;
    }
    const pinnedKeys = Array.isArray(remote.pinnedKeys)
      ? remote.pinnedKeys
      : null;
    const tourSeen = remote.tourSeen === true || this.state.tourSeen === true;
    this.setState({ pinnedKeys, tourSeen });
    saveNavPreferences({ pinnedKeys, tourSeen });
  };

  refreshPromotedEntitlementsIfNeeded = (location) => {
    const boxId = getSelectedBoxId() || '';
    const path = location && location.pathname ? location.pathname : '';
    const key = boxId + '|' + path;
    if (this._promotedEntitlementRefreshKey == null) {
      this._promotedEntitlementRefreshKey = key;
      return;
    }
    if (key === this._promotedEntitlementRefreshKey) {
      return;
    }
    this._promotedEntitlementRefreshKey = key;
    window.setTimeout(() => {
      this.loadPromotedEntitlements();
    }, 0);
  };

  loadPromotedEntitlements = () => {
    fetchEntitlements({ boxId: getSelectedBoxId() })
      .then((data) => {
        this.setState({
          promotedEntitlements: (data && data.entitlements) || [],
        });
      })
      .catch(() => {
        // Keep null so pinned products are not painted as locked on a failed fetch.
      });
  };

  getPromotedProductIcon = (featureKey) => {
    if (featureKey === 'counter') {
      return StoreIcon;
    }
    if (featureKey === 'curbside') {
      return DirectionsCarIcon;
    }
    if (featureKey === 'bedside') {
      return HotelIcon;
    }
    if (featureKey === 'kiosk_marketplace') {
      return ShoppingBagIcon;
    }
    if (featureKey === 'courier') {
      return LocalShippingIcon;
    }
    if (featureKey === 'custom_brand_messaging') {
      return ChatBubbleOutlineIcon;
    }
    if (featureKey === 'campaigns') {
      return CampaignIcon;
    }
    if (featureKey === 'kiosk_marketplace') {
      return ShoppingBagIcon;
    }
    return StorefrontIcon;
  };

  isPromotedProductSelected = (location, product) => {
    const lockedPath = `/home/features/${product.feature_key}`;
    if (isNavPathActive(location.pathname, lockedPath)) {
      return true;
    }
    if (product.feature_key === 'otc_delivery') {
      return isNavPathActive(location.pathname, '/home/manage/non-rx-catalog');
    }
    if (product.feature_key === 'kiosk_marketplace') {
      return isNavPathActive(location.pathname, '/home/manage/marketplace-bins');
    }
    if (product.feature_key === 'custom_brand_messaging') {
      return (
        isNavPathActive(location.pathname, '/home/manage/message-control-center') ||
        isNavPathActive(location.pathname, TEMPLATES_PATH_PREFIX, { prefix: true }) ||
        isNavPathActive(location.pathname, TEMPLATES_PATH_PREFIX)
      );
    }
    if (product.feature_key === 'campaigns') {
      return (
        isNavPathActive(location.pathname, CAMPAIGNS_PATH) ||
        isNavPathActive(location.pathname, CAMPAIGNS_PATH, { prefix: true })
      );
    }
    if (!isDeliverPrescriptionPath(location.pathname)) {
      return false;
    }
    const type = getConsoleTypeFromSearch(location.search);
    return !!(product.consoleType && type === product.consoleType);
  };

  wrapNavTitle = (title, node, key) => (
    <NavCollapsedTitle key={key} show={!this.props.drawerOpen} title={title}>
      {node}
    </NavCollapsedTitle>
  );

  canShowPromotedProduct = (product, showConsole) => {
    if (!product.requiresConsole) {
      return true;
    }
    return showConsole;
  };

  getPromotedNavSplit = (showConsole) =>
    splitPromotedNavItems(
      getVisiblePromotedProducts(showConsole).filter((product) =>
        this.canShowPromotedProduct(product, showConsole)
      ),
      this.state.promotedEntitlements,
      { pinnedKeys: this.state.pinnedKeys }
    );

  persistNavPreferences = (next) => {
    const pinnedKeys =
      next && Object.prototype.hasOwnProperty.call(next, 'pinnedKeys')
        ? next.pinnedKeys
        : this.state.pinnedKeys;
    const tourSeen =
      next && Object.prototype.hasOwnProperty.call(next, 'tourSeen')
        ? next.tourSeen
        : this.state.tourSeen;
    this._navPrefsDirty = true;
    this.setState({ pinnedKeys, tourSeen });
    saveNavPreferences({ pinnedKeys, tourSeen });
    persistNavPreferencesToApi({ pinnedKeys, tourSeen });
  };

  handleSavePinnedKeys = (pinnedKeys) => {
    this.persistNavPreferences({ pinnedKeys });
  };

  handleFinishNavTour = () => {
    this.persistNavPreferences({ tourSeen: true });
  };

  renderProductNavItem = (entry, location, options = {}) => {
    const { classes, t } = this.props;
    const product = entry.product;
    const entitlement = entry.entitlement;
    const locked =
      !isPromotedEntitlementPending(entitlement) &&
      !isFeatureUsable(entitlement);
    const geoBlocked = isFeatureGeoBlocked(entitlement);
    const IconComponent = this.getPromotedProductIcon(product.feature_key);
    const productLabel = displaySolutionTitle(
      product.feature_key,
      t(product.labelKey, {
        defaultValue: product.defaultLabel,
      })
    );
    const comingSoon =
      isComingSoonFeature(product.feature_key, product.defaultLabel) &&
      !isFeatureUsable(entitlement);
    const descriptionPage = options.descriptionPage === true;
    const descriptionPath = getFeatureLockedRedirectPath(product.feature_key);
    if (
      !descriptionPage &&
      product.feature_key === CUSTOM_BRAND_MESSAGING_KEY &&
      isFeatureUsable(entitlement)
    ) {
      return this.renderTemplatesMenu(location, { ...options, comingSoon });
    }
    if (
      !descriptionPage &&
      product.feature_key === CAMPAIGNS_KEY &&
      isFeatureUsable(entitlement)
    ) {
      return this.renderCampaignsMenu(location, { ...options, comingSoon });
    }
    const wrapCollapsed = options.wrapCollapsed !== false;
    const itemClassName = options.nested
      ? `${classes.listItem} ${classes.manageAccountsNested}`
      : classes.listItem;
    const node = (
      <ListItemButton
        className={itemClassName}
        component={Link}
        to={
          descriptionPage
            ? descriptionPath
            : product.feature_key === CUSTOM_BRAND_MESSAGING_KEY
            ? EMAIL_TEMPLATES_PATH
            : comingSoon && !isPromotedEntitlementPending(entitlement)
            ? descriptionPath
            : getPromotedProductNavPath(product, entitlement)
        }
        selected={
          descriptionPage
            ? isNavPathActive(location.pathname, descriptionPath)
            : this.isPromotedProductSelected(location, product)
        }
        onClick={() => {
          if (descriptionPage || comingSoon || locked || !product.consoleType) {
            return;
          }
          if (this.isPromotedProductSelected(location, product)) {
            return;
          }
          startDeliverTabLoading(product.consoleType);
        }}
        data-tour={
          product.feature_key === 'otc_delivery' ? 'marketplace-nav' : undefined
        }
      >
        <ListItemIcon>
          <IconComponent />
        </ListItemIcon>
        <ListItemText
          primary={
            <span className={classes.navItemLabel}>
              <span className={classes.navItemName}>{productLabel}</span>
              <span className={classes.navItemTrailing}>
                {comingSoon ? (
                  <span className="solution-coming-soon solution-coming-soon-nav">
                    {t('Solutions.ComingSoon', { defaultValue: 'Coming soon' })}
                  </span>
                ) : null}
                <span className={classes.navItemMark}>
                  {geoBlocked ? (
                    <NavLockedBubble
                      featureTitle={entitlement.title || product.defaultLabel}
                      status={t('Features.StatusGeo', {
                        defaultValue: 'Not available here',
                      })}
                      description={t('Features.GeoBlockedDetail', {
                        defaultValue:
                          'This location cannot offer this feature because of local rules.',
                      })}
                      placement={options.lockPlacement}
                    />
                  ) : locked ? (
                    <ActivateMark
                      label={t('Solutions.Activate', {
                        defaultValue: 'Activate',
                      })}
                    />
                  ) : null}
                </span>
              </span>
            </span>
          }
          primaryTypographyProps={{ component: 'div' }}
          className={classes.textColor}
          style={{ paddingLeft: '0px' }}
        />
      </ListItemButton>
    );
    if (!wrapCollapsed) {
      return node;
    }
    return this.wrapNavTitle(productLabel, node, product.feature_key);
  };

  renderStudioComingSoonMark = (comingSoon) => {
    const { classes, t } = this.props;
    if (!comingSoon) {
      return null;
    }
    return (
      <span className={classes.navItemTrailing}>
        <span className="solution-coming-soon solution-coming-soon-nav">
          {t('Solutions.ComingSoon', { defaultValue: 'Coming soon' })}
        </span>
      </span>
    );
  };

  renderTemplatesMenu = (location, options = {}) => {
    const { classes, t, drawerOpen } = this.props;
    const nested = options.nested === true;
    const comingSoon = options.comingSoon === true;
    const templatesSelected =
      isNavPathActive(location.pathname, TEMPLATES_PATH_PREFIX, {
        prefix: true,
      }) ||
      isNavPathActive(location.pathname, TEMPLATES_PATH_PREFIX) ||
      isNavPathActive(location.pathname, '/home/manage/message-control-center');
    const childClass = nested ? classes.submenuItemNested : classes.submenuItem;
    const studioLabel = t('Leftbar.Studio', { defaultValue: 'Studio' });
    const menuOpen = nested
      ? this.state.solutionsStudioOpen === true
      : isTopLevelNavSectionOpen(TOP_LEVEL_NAV.TEMPLATES);
    const flyout = (
      <NavMiniFlyout
        drawerOpen={drawerOpen}
        menuOpen={menuOpen}
        onMenuToggle={
          nested ? this.handleSolutionsStudioToggle : this.handleTemplatesClick
        }
        selected={templatesSelected}
        buttonClassName={
          nested
            ? `${classes.listItem} ${classes.manageAccountsNested}`
            : classes.listItem
        }
        anchorComponent={Link}
        anchorTo={EMAIL_TEMPLATES_PATH}
        icon={
          <ListItemIcon>
            <ChatBubbleOutlineIcon />
          </ListItemIcon>
        }
        label={
          <span className={classes.navItemLabel}>
            <span className={classes.navItemName}>{studioLabel}</span>
            {this.renderStudioComingSoonMark(comingSoon)}
          </span>
        }
        labelClassName={classes.textColor}
        flyoutMinWidth={260}
      >
        <List component="div" disablePadding className={classes.submenuIndent}>
          <ListItemButton
            className={childClass}
            component={Link}
            to={EMAIL_TEMPLATES_PATH}
            selected={isNavPathActive(location.pathname, EMAIL_TEMPLATES_PATH)}
          >
            <ListItemIcon className={classes.nestedNavIcon}>
              <EmailOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={t('Leftbar.EmailTemplates', {
                defaultValue: 'Email templates',
              })}
              className={classes.textColor}
              style={{ paddingLeft: '0px' }}
            />
          </ListItemButton>
          <ListItemButton
            className={childClass}
            component={Link}
            to={SMS_TEMPLATES_PATH}
            selected={isNavPathActive(location.pathname, SMS_TEMPLATES_PATH)}
          >
            <ListItemIcon className={classes.nestedNavIcon}>
              <SmsOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={t('Leftbar.SmsTemplates', {
                defaultValue: 'SMS templates',
              })}
              className={classes.textColor}
              style={{ paddingLeft: '0px' }}
            />
          </ListItemButton>
          <ListItemButton
            className={childClass}
            component={Link}
            to={LINK_MESSAGES_PATH}
            selected={isNavPathActive(location.pathname, LINK_MESSAGES_PATH)}
          >
            <ListItemIcon className={classes.nestedNavIcon}>
              <LinkOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={t('Leftbar.LinkTemplates', {
                defaultValue: 'Link templates',
              })}
              className={classes.textColor}
              style={{ paddingLeft: '0px' }}
            />
          </ListItemButton>
          <ListItemButton
            className={childClass}
            component={Link}
            to={STAFF_TEMPLATES_PATH}
            selected={isNavPathActive(location.pathname, STAFF_TEMPLATES_PATH)}
          >
            <ListItemIcon className={classes.nestedNavIcon}>
              <BadgeOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={t('Leftbar.StaffMail', {
                defaultValue: 'Staff mail',
              })}
              className={classes.textColor}
              style={{ paddingLeft: '0px' }}
            />
          </ListItemButton>
        </List>
      </NavMiniFlyout>
    );
    return (
      <React.Fragment key={CUSTOM_BRAND_MESSAGING_KEY}>{flyout}</React.Fragment>
    );
  };

  renderCampaignsMenu = (location, options = {}) => {
    const { classes, t, drawerOpen } = this.props;
    const nested = options.nested === true;
    const comingSoon = options.comingSoon === true;
    const campaignsSelected =
      isNavPathActive(location.pathname, CAMPAIGNS_PATH) ||
      isNavPathActive(location.pathname, CAMPAIGNS_PATH, { prefix: true });
    const childClass = nested ? classes.submenuItemNested : classes.submenuItem;
    const campaignsLabel = t('Leftbar.Campaigns', { defaultValue: 'Campaigns' });
    const menuOpen = nested
      ? this.state.solutionsCampaignsOpen === true
      : isTopLevelNavSectionOpen(TOP_LEVEL_NAV.CAMPAIGNS);
    const flyout = (
      <NavMiniFlyout
        drawerOpen={drawerOpen}
        menuOpen={menuOpen}
        onMenuToggle={
          nested
            ? this.handleSolutionsCampaignsToggle
            : this.handleCampaignsClick
        }
        selected={campaignsSelected}
        buttonClassName={
          nested
            ? `${classes.listItem} ${classes.manageAccountsNested}`
            : classes.listItem
        }
        icon={
          <ListItemIcon>
            <CampaignIcon />
          </ListItemIcon>
        }
        label={
          <span className={classes.navItemLabel}>
            <span className={classes.navItemName}>{campaignsLabel}</span>
            {this.renderStudioComingSoonMark(comingSoon)}
          </span>
        }
        labelClassName={classes.textColor}
        flyoutMinWidth={240}
      >
        <List component="div" disablePadding className={classes.submenuIndent}>
          <ListItemButton
            className={childClass}
            component={Link}
            to={CAMPAIGNS_LIST_PATH}
            selected={
              isNavPathActive(location.pathname, CAMPAIGNS_LIST_PATH) ||
              isNavPathActive(location.pathname, CAMPAIGNS_PATH)
            }
          >
            <ListItemIcon className={classes.nestedNavIcon}>
              <ViewListIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={t('Leftbar.CampaignList', {
                defaultValue: 'View campaigns',
              })}
              className={classes.textColor}
              style={{ paddingLeft: '0px' }}
            />
          </ListItemButton>
          <ListItemButton
            className={childClass}
            component={Link}
            to={CAMPAIGNS_ANALYTICS_PATH}
            selected={isNavPathActive(
              location.pathname,
              CAMPAIGNS_ANALYTICS_PATH
            )}
          >
            <ListItemIcon className={classes.nestedNavIcon}>
              <AssessmentIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={t('Leftbar.CampaignAnalytics', {
                defaultValue: 'Analytics',
              })}
              className={classes.textColor}
              style={{ paddingLeft: '0px' }}
            />
          </ListItemButton>
        </List>
      </NavMiniFlyout>
    );
    return <React.Fragment key={CAMPAIGNS_KEY}>{flyout}</React.Fragment>;
  };

  renderPromotedProducts = (location, showConsole) => {
    const { classes, t, drawerOpen } = this.props;
    const split = this.getPromotedNavSplit(showConsole);
    const expanded = this.state.productsExpanded;
    const items = (split.top || []).filter((entry) => entry && entry.product);
    if (!items.length) {
      return null;
    }
    const showItems = !drawerOpen || expanded;
    return (
      <React.Fragment>
        {drawerOpen ? (
          <button
            type="button"
            className={classes.productsSectionLabel}
            data-nav-tour="products"
            aria-expanded={expanded}
            onClick={this.handleProductsClick}
          >
            <span>{t('Leftbar.Products', { defaultValue: 'Products' })}</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <span
                role="presentation"
                className={classes.customizeNavButton}
                data-nav-tour="customize"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  this.setState({ customizeOpen: true });
                }}
              >
                {t('NavCustomize.Open', { defaultValue: 'Customize' })}
              </span>
              {expanded ? (
                <ExpandLess className="nav-section-chevron" />
              ) : (
                <ExpandMore className="nav-section-chevron" />
              )}
            </span>
          </button>
        ) : null}
        {showItems
          ? items.map((entry) => this.renderProductNavItem(entry, location))
          : null}
        <Divider style={{ margin: '2px 0' }} />
      </React.Fragment>
    );
  };

  isFeaturesSelected = (location) => {
    if (isPromotedFeaturePath(location.pathname)) {
      return false;
    }
    return isNavPathActive(location.pathname, '/home/features', { prefix: true });
  };

  isManageAccountsSelected = (location) =>
    isNavPathActive(location.pathname, '/home/manage/accounts');

  isMarketplaceReportsSectionActive = (location) =>
    isMarketplaceReportPath(location.pathname);

  isManageAccountsSectionActive = (location) =>
    this.isManageAccountsSelected(location) ||
    isNavPathActive(location.pathname, '/home/manage/product-licensing') ||
    isNavPathActive(location.pathname, '/home/manage/feature-catalog') ||
    this.isMarketplaceReportsSectionActive(location);

  isIlocalInternalUser = () => {
    try {
      return localStorage.getItem('isIlocalUser') === 'true';
    } catch (e) {
      return false;
    }
  };

  getManageSectionRibbonClass = (sectionId) => {
    if (sectionId === 'licensing-reports') {
      return 'report-cat-ribbon report-cat-licensing';
    }
    return 'report-cat-ribbon manage-cat-' + sectionId;
  };

  getManageSectionOpen = (sectionId) => {
    if (sectionId === 'features') {
      return this.state.solutionsOpen === true;
    }
    return this.state.manageAccountsSectionsOpen[sectionId] === true;
  };

  handleManageSectionClick = (sectionId) => {
    if (sectionId === 'features') {
      this.setState({ solutionsOpen: !this.state.solutionsOpen });
      return;
    }
    const currentlyOpen = this.getManageSectionOpen(sectionId);
    this.setState({
      manageAccountsSectionsOpen: currentlyOpen ? {} : { [sectionId]: true },
    });
  };

  handleProductsClick = () => {
    this.setState((state) => ({
      productsExpanded: !state.productsExpanded,
    }));
  };

  isManageSectionActive = (location, paths) =>
    paths.some((sectionPath) => {
      if (sectionPath === '/home/features') {
        return this.isFeaturesSelected(location);
      }
      return isNavPathActive(location.pathname, sectionPath, { prefix: true });
    });

  renderManageAccountsSection = (
    sectionId,
    label,
    IconComponent,
    location,
    activePaths,
    children,
    linkTo,
    topLevel
  ) => {
    const { classes } = this.props;
    const sectionActive = this.isManageSectionActive(location, activePaths);
    const sectionOpen = this.getManageSectionOpen(sectionId);
    const toggleClass =
      `${classes.listItem}${topLevel ? '' : ` ${classes.manageSectionToggle}`} ` +
      this.getManageSectionRibbonClass(sectionId) +
      (this.props.drawerOpen ? "" : " nav-flyout-section-toggle");
    return (
      <React.Fragment key={sectionId}>
        <ListItemButton
          {...(linkTo ? { component: Link, to: linkTo } : {})}
          onClick={() => this.handleManageSectionClick(sectionId)}
          className={toggleClass}
          selected={sectionActive}
          aria-expanded={sectionOpen}
          data-tour={sectionId === 'features' ? 'features-nav' : undefined}
        >
          {IconComponent ? (
            <ListItemIcon className={topLevel ? undefined : classes.nestedNavIcon}>
              <IconComponent fontSize="small" />
            </ListItemIcon>
          ) : null}
          <ListItemText
            primary={label}
            className={topLevel ? classes.textColor : classes.manageSectionLabel}
            style={{ paddingLeft: '0px' }}
          />
          <span className="nav-mini-flyout-chevron" data-nav-chevron="true" aria-hidden="true">
            {sectionOpen ? (
              <ExpandLess className="nav-section-chevron" />
            ) : (
              <ExpandMore className="nav-section-chevron" />
            )}
          </span>
        </ListItemButton>
        <Collapse in={sectionOpen} timeout="auto" unmountOnExit>
          <div
            className={
              this.props.drawerOpen
                ? classes.manageSectionMenu
                : "nav-flyout-section-menu"
            }
          >
            {children}
          </div>
        </Collapse>
      </React.Fragment>
    );
  };

  isRetailFeaturesVisible = (_isRetail) =>
    [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail);

  renderSolutionsSection = (location, _isRetail, showConsole) => {
    const { t } = this.props;
    if (!this.isRetailFeaturesVisible(_isRetail)) {
      return null;
    }
    const featuresLabel = t('Leftbar.Features', { defaultValue: 'Solutions' });
    const solutionSplit = this.getPromotedNavSplit(!!showConsole);
    const studioInProducts = (solutionSplit.top || []).some(
      (entry) =>
        entry &&
        entry.product &&
        entry.product.feature_key === CUSTOM_BRAND_MESSAGING_KEY
    );
    const allSolutions = (solutionSplit.top || [])
      .concat(solutionSplit.more || [])
      .filter(
        (entry) =>
          !studioInProducts ||
          !(
            entry &&
            entry.product &&
            entry.product.feature_key === CUSTOM_BRAND_MESSAGING_KEY
          )
      );
    return this.renderManageAccountsSection(
      'features',
      featuresLabel,
      ExtensionIcon,
      location,
      ['/home/features'],
      <React.Fragment>
        {allSolutions.map((entry) =>
          this.renderProductNavItem(entry, location, {
            nested: true,
            wrapCollapsed: false,
            descriptionPage: true,
          })
        )}
      </React.Fragment>,
      '/home/features',
      true
    );
  };

  renderManageAccountsSubmenu = (location) => {
    const { classes, t } = this.props;
    const isIlocal = this.isIlocalInternalUser();
    const licensingLabel = t('Leftbar.ManageCategory.LicensingCatalog', {
      defaultValue: 'Licensing & Catalog',
    });
    const licensingReportsLabel = t('Leftbar.LicensingReports', {
      defaultValue: 'Licensing Reports',
    });
    return (
      <React.Fragment>
        {isIlocal
          ? this.renderManageAccountsSection(
              'licensing-mgmt',
              licensingLabel,
              VerifiedUserIcon,
              location,
              [
                '/home/manage/product-licensing',
                '/home/manage/feature-catalog',
              ],
              <React.Fragment>
                <ListItemButton
                  className={`${classes.listItem} ${classes.manageAccountsNested}`}
                  component={Link}
                  to="/home/manage/product-licensing"
                  selected={isNavPathActive(location.pathname, '/home/manage/product-licensing')}
                  data-tour="product-licensing-nav"
                >
                  <ListItemIcon className={classes.nestedNavIcon}>
                    <VerifiedUserIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Leftbar.ProductLicensing")}
                    className={classes.textColor}
                    style={{ paddingLeft: '0px' }}
                  />
                </ListItemButton>
                <ListItemButton
                  className={`${classes.listItem} ${classes.manageAccountsNested}`}
                  component={Link}
                  to="/home/manage/feature-catalog"
                  selected={isNavPathActive(location.pathname, '/home/manage/feature-catalog')}
                >
                  <ListItemIcon className={classes.nestedNavIcon}>
                    <MenuBookIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Leftbar.FeatureCatalog")}
                    className={classes.textColor}
                    style={{ paddingLeft: '0px' }}
                  />
                </ListItemButton>
              </React.Fragment>
            )
          : null}
        {isIlocal
          ? this.renderManageAccountsSection(
              'licensing-reports',
              licensingReportsLabel,
              AssessmentIcon,
              location,
              MARKETPLACE_REPORT_PATHS,
              <ReportLink sectionLinksOnly marketplaceReportsOnly />
            )
          : null}
      </React.Fragment>
    );
  };

  componentWillUnmount() {
    if (this._navAccordionUnsub) {
      this._navAccordionUnsub();
    }
    if (this._onPromotedEntitlementFocus) {
      window.removeEventListener('focus', this._onPromotedEntitlementFocus);
    }
    if (this._onOpenSolutionsNav) {
      window.removeEventListener(
        'ilocalbox:open-solutions-nav',
        this._onOpenSolutionsNav
      );
    }
    this.setState({ notification: false });
  }

  render() {
    const { classes, t, hasCounterLocations, drawerOpen } = this.props;
    const currentLang = localStorage.getItem('i18nextLng');
    const _isRetail = localStorage.getItem('isRetail');
    const stockerGated = isStockerNavGated();
    const showManageLocation = canShowNavItem('Manage Boxes');
    const showManagePatients = canShowNavItem('Manage Patients');
    const showManageUsers = canShowNavItem('Manage Users');
    const showManageGroups = canShowNavItem('Manage Groups');
    const showManageRoles = canShowNavItem('Manage Roles');
    const showManageAccounts = canShowNavItem('Manage Accounts');
    const showAnnouncement = canShowNavItem('Manage Announcement');
    const showConsole = !stockerGated || hasAllowedPermission({ name: 'View Delivery Console' }) || hasAllowedPermission({ name: 'Console Report' });
    const showVendors = !stockerGated && [true, 'true'].includes(localStorage.getItem('isIlocalUser')) && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail);
    const showBilling = (() => {
      try {
        const isIlocalUserValue = localStorage.getItem('isIlocalUser');
        if (isIlocalUserValue !== 'true') {
          return false;
        }
        if (stockerGated) {
          return hasAllowedPermission({ entityType: 'Manage Users', name: 'Billing' });
        }
        return true;
      } catch (e) {
        console.error('Error checking billing permissions:', e);
        return false;
      }
    })();
    return (
      <React.Fragment>
        <NavWalkthrough
          open={drawerOpen && this.state.tourSeen !== true}
          onFinish={this.handleFinishNavTour}
          t={t}
        />
        <Location>
        {({ location }) => {
          this.refreshPromotedEntitlementsIfNeeded(location);
          this._navShowConsole = !!(showConsole && currentLang === 'en');
          this._currentOnTemplates = this.isStudioPath(location.pathname);
          this._currentOnCampaigns = this.isCampaignsPath(location.pathname);
          return (
      <div id='react-no-print' className={classes.root}>
        {this.state.DeliveryTech ? (
          <div>
            {this.wrapNavTitle(
              t("Leftbar.Console"),
              <Link to="/home/manage/console" className={classes.navLink}>
              <ListItemButton
                className={classes.listItem}
                selected={isNavPathActive(location.pathname, '/home/manage/console')}
              >
                <ListItemIcon>
                  <ConsoleIcon />
                </ListItemIcon>
                <ListItemText primary={t("Leftbar.Console")} className={classes.textColor}/>
              </ListItemButton>
            </Link>
            )}
            <Divider />
            <Report />
            {/* Help & Tours menu item for DeliveryTech */}
            {!stockerGated && (
            <React.Fragment>
            <Divider style={{ margin: '2px 0' }} />
            <div data-tour="help-tours-menu">
            <NavMiniFlyout
              drawerOpen={drawerOpen}
              menuOpen={isTopLevelNavSectionOpen(TOP_LEVEL_NAV.HELP_TOURS)}
              onMenuToggle={this.handleHelpToursClick}
              selected={false}
              buttonClassName={classes.listItem}
              icon={
                <ListItemIcon>
                  <HelpOutlineIcon />
                </ListItemIcon>
              }
              label={t("Leftbar.HelpAndTours")}
              labelClassName={classes.textColor}
              flyoutMinWidth={300}
            >
              {this.renderHelpTourItems()}
            </NavMiniFlyout>
            </div>
            </React.Fragment>
            )}
          </div>
        )
          :
          (
            <div>
              {this.isRetailFeaturesVisible(_isRetail)
                ? this.renderPromotedProducts(
                    location,
                    showConsole && currentLang === 'en'
                  )
                : null}
              {showManageLocation && this.wrapNavTitle(
                t("Leftbar.ManageLocation"),
              <Link to="/home/manage/locations" className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManageBoxesIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Leftbar.ManageLocation")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              )}
              {showManageUsers && (
              this.state.rolepermissionmenu === true ? (
                <NavMiniFlyout
                  drawerOpen={drawerOpen}
                  menuOpen={isTopLevelNavSectionOpen(TOP_LEVEL_NAV.MANAGE_USERS)}
                  onMenuToggle={this.handleManageUsersClick}
                  selected={
                    isNavPathActive(location.pathname, '/home/manage/roles') ||
                    isNavPathActive(location.pathname, '/home/user-role/rolepermissions') ||
                    isNavPathActive(location.pathname, '/home/user-role/pushPermissions')
                  }
                  buttonClassName={classes.listItem}
                  anchorComponent={Link}
                  anchorTo="/home/manage/users/0"
                  icon={
                    <ListItemIcon>
                      <ManageUsersIcon />
                    </ListItemIcon>
                  }
                  label={t("Leftbar.ManageUsers")}
                  labelClassName={classes.textColor}
                  labelStyle={{ paddingLeft: '0px' }}
                  flyoutMinWidth={260}
                >
                  <List component="div" disablePadding>
                    <ListItemButton
                      className={`${classes.listItem} ${classes.nested}`}
                      component={Link}
                      to="/home/manage/roles"
                      selected={isNavPathActive(location.pathname, '/home/manage/roles')}
                    >
                      <ListItemIcon className={classes.nestedNavIcon}>
                        <AttributionIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Roles.ManageRolesTitle")}
                        className={classes.textColor}
                        style={{ paddingLeft: '0px' }}
                      />
                    </ListItemButton>
                    <ListItemButton
                      className={`${classes.listItem} ${classes.nested}`}
                      component={Link}
                      to="/home/user-role/rolepermissions"
                      selected={isNavPathActive(location.pathname, '/home/user-role/rolepermissions')}
                    >
                      <ListItemIcon className={classes.nestedNavIcon}>
                        <AdminPanelSettingsIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Leftbar.RolePermissions")}
                        className={classes.textColor}
                        style={{ paddingLeft: '0px' }}
                      />
                    </ListItemButton>
                    <ListItemButton
                      className={`${classes.listItem} ${classes.nested}`}
                      component={Link}
                      to="/home/user-role/pushPermissions"
                      selected={isNavPathActive(location.pathname, '/home/user-role/pushPermissions')}
                    >
                      <ListItemIcon className={classes.nestedNavIcon}>
                        <NotificationsActiveIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("Leftbar.PushPermission")}
                        className={classes.textColor}
                        style={{ paddingLeft: '0px' }}
                      />
                    </ListItemButton>
                  </List>
                </NavMiniFlyout>
              ) : this.wrapNavTitle(
                t("Leftbar.ManageUsers"),
                <Link tag="a" to="/home/manage/users/0" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <ManageUsersIcon />
                    </ListItemIcon>
                    <ListItemText inset primary={t("Leftbar.ManageUsers")} className={classes.textColor} style={{paddingLeft:'0px'}}/>
                  </ListItemButton>
                </Link>
              )
              )}
              {showManageRoles && this.state.rolepermissionmenu !== true ? this.wrapNavTitle(
                t("Roles.ManageRolesTitle"),
                <Link to="/home/manage/roles" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <AttributionIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Roles.ManageRolesTitle")} className={classes.textColor}/>
                  </ListItemButton>
                </Link>
              ) : null}
              {showManagePatients && this.wrapNavTitle(
                [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? t("Leftbar.ManagePatient") : t("Leftbar.ManageCustomers"),
              <Link to={[false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? "/home/manage/patients" : "/home/manage/customers"} className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManagePatientsIcon />
                  </ListItemIcon>
                  <ListItemText primary={ [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? t("Leftbar.ManagePatient") : t("Leftbar.ManageCustomers") } className={classes.textColor}/>
                </ListItemButton>
              </Link>
              )}
              {showManageGroups && this.wrapNavTitle(
                t("Groups.ManageGroupsTitle"),
              <Link to="/home/manage/groups" className={classes.navLink}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Groups.ManageGroupsTitle")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              )}
              {
                showVendors ? this.wrapNavTitle(
                  t("Leftbar.ManageVendors"),
                  <Link tag="a" to="/home/manage/vendors" className={classes.navLink}>
                    <ListItemButton className={classes.listItem}>
                      <ListItemIcon>
                        <BusinessIcon />
                      </ListItemIcon>
                      <ListItemText inset primary={t("Leftbar.ManageVendors")} className={classes.textColor} style={{ paddingLeft: '0px' }} />
                    </ListItemButton>
                  </Link>
                ) : null
              }
              {showManageLocation && hasCounterLocations && this.wrapNavTitle(
                t("Leftbar.BinMapping"),
                <Link to="/home/manage/locations/bin-mapping" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <MapIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.BinMapping")} className={classes.textColor}/>
                  </ListItemButton>
                </Link>
              )}
              {this.renderSolutionsSection(
                location,
                _isRetail,
                showConsole && currentLang === 'en'
              )}
              {showManageAccounts && (
              <NavMiniFlyout
                drawerOpen={drawerOpen}
                menuOpen
                showChevron={false}
                selected={
                  drawerOpen
                    ? this.isManageAccountsSelected(location)
                    : this.isManageAccountsSectionActive(location)
                }
                buttonClassName={classes.listItem}
                anchorComponent={Link}
                anchorTo="/home/manage/accounts"
                icon={
                  <ListItemIcon>
                    <ManageAccountsIcon />
                  </ListItemIcon>
                }
                label={t("Leftbar.ManageAccounts")}
                labelClassName={classes.textColor}
                flyoutMinWidth={300}
              >
                <List component="div" disablePadding>
                  {this.renderManageAccountsSubmenu(location)}
                </List>
              </NavMiniFlyout>
              )}
              {showConsole && (currentLang === 'en' && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail)) &&
                this.wrapNavTitle(
                  t("Leftbar.Console"),
                <Link to="/home/manage/console" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <ConsoleIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Console")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              )}
              {showAnnouncement && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) &&
                this.wrapNavTitle(
                  t("Leftbar.Announcement"),
                <Link to="/home/manage/releaseHistory" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <NotificationsIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Announcement")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              )}
              {showBilling ? this.wrapNavTitle(
                t("Leftbar.Billing"),
                <Link to="/home/billing" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <PaymentIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Billing")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              ) : null}
              {/* Help & Tours menu item */}
              {!stockerGated && (
              <React.Fragment>
              <Divider style={{ margin: '2px 0' }} />
              <div data-tour="help-tours-menu">
              <NavMiniFlyout
                drawerOpen={drawerOpen}
                menuOpen={isTopLevelNavSectionOpen(TOP_LEVEL_NAV.HELP_TOURS)}
                onMenuToggle={this.handleHelpToursClick}
                selected={false}
                buttonClassName={classes.listItem}
                icon={
                  <ListItemIcon>
                    <HelpOutlineIcon />
                  </ListItemIcon>
                }
                label={t("Leftbar.HelpAndTours")}
                labelClassName={classes.textColor}
                flyoutMinWidth={300}
              >
                {this.renderHelpTourItems()}
              </NavMiniFlyout>
              </div>
              </React.Fragment>
              )}
              {/* {(currentLang === 'en' && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail)) &&
                <Link to="/home/manage/appointment" className={classes.navLink}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <EventIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Appointment")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              } */}
              <CustomizeNavDialog
                open={this.state.customizeOpen}
                onClose={() => this.setState({ customizeOpen: false })}
                onSave={this.handleSavePinnedKeys}
                rankedProducts={rankPromotedProducts(
                  getVisiblePromotedProducts(
                    showConsole && currentLang === 'en'
                  ),
                  this.state.promotedEntitlements
                )}
                pinnedKeys={
                  Array.isArray(this.state.pinnedKeys)
                    ? this.state.pinnedKeys
                    : this.getPromotedNavSplit(showConsole && currentLang === 'en')
                        .top.map((entry) => entry.product.feature_key)
                }
                t={t}
              />
            </div>
          )
        }
      </div>
          );
        }}
        </Location>
      </React.Fragment>
    );
  }
}

MenuList.propTypes = {
  classes: PropTypes.object.isRequired,
  onStartTour: PropTypes.func,
  onStartFeaturesTour: PropTypes.func,
  onOpenFeaturesHelp: PropTypes.func,
  hasCounterLocations: PropTypes.bool,
  drawerOpen: PropTypes.bool,
};

MenuList.defaultProps = {
  drawerOpen: true,
};

export default withStyles(styles)(withTranslation()(MenuList));



// WEBPACK FOOTER //
// ./src/components/leftnav/Managemenulink.js